import cx from 'classnames';
import { Icon, Text, TIcon, TIconSizes } from '@intellecteu/common-ui';
import { useAppConfig } from 'app/utils';
import {
  applicationsPath,
  collectionsPath,
  monitoringPath,
  domainsPath,
  Labels,
  participantsPath,
  remoteDomainsPath,
  remoteParticipantsPath,
  validatorsPath,
} from 'app/constants';
import { FileType } from 'data';
import { Item, Sector, Sidebar } from 'ui';

import s from './styles.module.scss';

interface ISidebarContainer {
  collapsed: boolean;
}

interface IItemWrapper extends ISidebarContainer {
  to: string | string[]; // support multiple paths
  label: string;
  icon: TIcon;
  size?: TIconSizes;
}

const ItemWrapper = ({ collapsed, to, label, icon, size }: IItemWrapper) => (
  <Item className={s.icon} to={to} icon={icon} collapsed={collapsed} size={size}>
    {collapsed ? '' : label}
  </Item>
);

export const SidebarContainer = ({ collapsed = false }: ISidebarContainer) => {
  const { version } = useAppConfig();

  return (
    <Sidebar>
      <Sector collapsed={collapsed}>
        <ItemWrapper label={Labels.MONITORING} collapsed={collapsed} to={monitoringPath} icon={Icon.icons.dashboard} />

        <ItemWrapper
          collapsed={collapsed}
          to={[domainsPath, remoteDomainsPath]}
          label={Labels.DOMAINS}
          icon={Icon.icons.peer}
        />
        <ItemWrapper
          collapsed={collapsed}
          to={[participantsPath, remoteParticipantsPath]}
          label={Labels.PARTICIPANTS}
          icon={Icon.icons.partners}
        />
        <ItemWrapper
          collapsed={collapsed}
          to={applicationsPath}
          label={Labels.APPLICATIONS}
          icon={Icon.icons.channels}
        />
        <ItemWrapper
          collapsed={collapsed}
          to={[collectionsPath(FileType.DAR), collectionsPath(FileType.UI_PACKAGE)]}
          label={Labels.COLLECTIONS}
          icon={Icon.icons.collections}
        />
        <ItemWrapper collapsed={collapsed} to={validatorsPath} label={Labels.VALIDATORS} icon={Icon.icons.user} />
      </Sector>

      <Sector label={Labels.VERSION} collapsed={collapsed}>
        <Text
          size={collapsed ? 'xxs' : 's'}
          color="simpleWhite"
          className={cx(s.version, collapsed && s.versionCollapsed)}
        >
          <span id="ui_version">{version}</span>
        </Text>
      </Sector>
    </Sidebar>
  );
};
